module.exports = __webpack_public_path__ + "static/media/bg-referral-letter.5d79cd8e.png";